import { GenericError } from '../../../errors/shared/genericError.js';
import { UnknownError } from '../../../errors/shared/base.js';
import { createELKErrorLog, createELKMessageLog } from './ELKLogs.js';
import { LogLevel } from './ILog.js';

const BASE_ERR_DOMAIN = 'core.logger';
function convertLogMessageToELKLog(level, message, meta) {
    if (GenericError.isLike(message) || message instanceof Error) {
        switch (level) {
            case LogLevel.Trace:
            case LogLevel.Info:
                return createELKMessageLog({
                    level,
                    message: message.message,
                    meta,
                });
            default:
                return createELKErrorLog({
                    level,
                    message,
                    meta,
                });
        }
    }
    else {
        switch (level) {
            case LogLevel.Error:
            case LogLevel.Fatal:
                return createELKErrorLog({
                    level,
                    message: new UnknownError({
                        message,
                        domain: `${BASE_ERR_DOMAIN}.${level}.unknown-domain`,
                    }),
                    meta,
                });
            default:
                return createELKMessageLog({
                    level,
                    message,
                    meta,
                });
        }
    }
}

export { convertLogMessageToELKLog };
//# sourceMappingURL=convertLogMessageToELKLog.js.map
